export const rowClassName = (record, index) => {
    if (record.isAction) return "apartments-action-row"
    return (index + 1) % 2 === 0 ? "ant-table-second-color" : ""
}